import {
  GET_LABREQUESTTEST,
  GET_LABREQUESTTEST_FAIL,
  GET_LABREQUESTTEST_SUCCESS,
  GET_LABREQUESTTESTS,
  GET_LABREQUESTTESTS_FAIL,
  GET_LABREQUESTTESTS_SUCCESS,
  ADD_NEW_LABREQUESTTEST,
  ADD_LABREQUESTTEST_SUCCESS,
  ADD_LABREQUESTTEST_FAIL,
  UPDATE_LABREQUESTTEST,
  UPDATE_LABREQUESTTEST_SUCCESS,
  UPDATE_LABREQUESTTEST_FAIL,
  DELETE_LABREQUESTTEST,
  DELETE_LABREQUESTTEST_SUCCESS,
  DELETE_LABREQUESTTEST_FAIL,
  SET_STATE_LABREQUESTTEST,
  MASSIVE_STATUS_UPDATE,
  MASSIVE_STATUS_UPDATE_SUCCESS,
  MASSIVE_STATUS_UPDATE_FAIL
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABREQUESTTEST,
  payload: loading,
})

export const getLabRequestTests = ( params ) => ({
  type: GET_LABREQUESTTESTS,
  payload: { params },
})

export const getLabRequestTestsSuccess = (labRequestTests, totalPages, currentPage) => ({
  type: GET_LABREQUESTTESTS_SUCCESS,
  payload: { labRequestTests:labRequestTests, total:totalPages, currentPage:currentPage}
})

export const getLabRequestTestsFail = error => ({
  type: GET_LABREQUESTTESTS_FAIL,
  payload: error,
})

export const addNewLabRequestTest = labRequestTest => ({
  type: ADD_NEW_LABREQUESTTEST,
  payload: labRequestTest,
})

export const addLabRequestTestSuccess = labRequestTest => ({
  type: ADD_LABREQUESTTEST_SUCCESS,
  payload: labRequestTest,
})  

export const addLabRequestTestFail = error => ({
  type: ADD_LABREQUESTTEST_FAIL,
  payload: error,
})

export const updateLabRequestTest = labRequestTest => ({
  type: UPDATE_LABREQUESTTEST,
  payload: labRequestTest,
})

export const updateLabRequestTestSuccess = labRequestTest => ({
  type: UPDATE_LABREQUESTTEST_SUCCESS,
  payload: labRequestTest,
})

export const updateLabRequestTestFail = error => ({
  type: UPDATE_LABREQUESTTEST_FAIL,
  payload: error,
})

export const deleteLabRequestTest = labRequestTest => ({
  type: DELETE_LABREQUESTTEST,
  payload: labRequestTest,
})

export const deleteLabRequestTestSuccess = id => ({
  type: DELETE_LABREQUESTTEST_SUCCESS,
  id,
})

export const deleteLabRequestTestFail = error => ({
  type: DELETE_LABREQUESTTEST_FAIL,
  payload: error,
})

export const getLabRequestTest = () => ({
  type: GET_LABREQUESTTEST,
})

export const getLabRequestTestSuccess = labRequestTest => ({
  type: GET_LABREQUESTTEST_SUCCESS,
  payload: labRequestTest,
})

export const getLabRequestTestFail = error => ({
  type: GET_LABREQUESTTEST_FAIL,
  payload: error,
})

export const massiveStatusUpdate = (labRequestId, statusTest) => ({
  type: MASSIVE_STATUS_UPDATE,
  payload: { labRequestId, statusTest },
});

export const massiveStatusUpdateSuccess = () => ({
  type: MASSIVE_STATUS_UPDATE_SUCCESS,
});

export const massiveStatusUpdateFail = error => ({
  type: MASSIVE_STATUS_UPDATE_FAIL,
  payload: error,
});
